import { doc, getDoc, setDoc, updateDoc } from 'firebase/firestore';
import { db } from '../config';

export interface MarketingSettings {
  defaultSenderName: string;
  defaultSenderEmail: string;
  complianceFooter: string;
  brandingLogoUrl?: string;
  unsubscribeLinkText?: string;
  updatedAt: number;
}

const MARKETING_SETTINGS_DOC_ID = 'marketing';
const marketingSettingsRef = doc(db, 'settings', MARKETING_SETTINGS_DOC_ID);

export const getMarketingSettings = async (): Promise<MarketingSettings | null> => {
  const docSnap = await getDoc(marketingSettingsRef);
  if (docSnap.exists()) {
    return docSnap.data() as MarketingSettings;
  }
  return null;
};

export const updateMarketingSettings = async (settings: Partial<MarketingSettings>): Promise<void> => {
  await setDoc(marketingSettingsRef, {
    ...settings,
    updatedAt: Date.now(),
  }, { merge: true });
}; 